// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/common/lang.proto" (package "proto.common", syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/common/lang.proto" (package "proto.common", syntax proto3)
// tslint:disable

/**
 * @generated from protobuf enum proto.common.Lang
 */
export var Lang;

(function (Lang) {
  /**
   * @generated from protobuf enum value: lang_unknown = 0;
   */
  Lang[Lang["lang_unknown"] = 0] = "lang_unknown";
  /**
   * @generated from protobuf enum value: ru = 1;
   */

  Lang[Lang["ru"] = 1] = "ru";
  /**
   * @generated from protobuf enum value: en = 2;
   */

  Lang[Lang["en"] = 2] = "en";
})(Lang || (Lang = {}));